import { ref, onMounted, onUnmounted } from 'vue'
import { useNuxtApp } from '#app'
import {
  getRequestUserAgent,
  getViewportWidthByUserAgent,
  shouldUseUserAgentViewport,
} from '~/utils/ssrDevice'

export function useWindowResize() {
  const nuxtApp = useNuxtApp()
  const initialWidth = shouldUseUserAgentViewport(nuxtApp)
    ? getViewportWidthByUserAgent(getRequestUserAgent(nuxtApp))
    : window.innerWidth
  const windowWidth = ref(initialWidth)
  const windowHeight = ref(0)
  const isMobile = ref(initialWidth < 768)
  const isTablet = ref(initialWidth >= 768 && initialWidth < 1024)
  const isDesktop = ref(initialWidth >= 1024)

  // 更新窗口尺寸
  const updateWindowSize = () => {
    if (process.client) {
      windowWidth.value = window.innerWidth
      windowHeight.value = window.innerHeight
      
      // 根据屏幕宽度判断设备类型
      isMobile.value = windowWidth.value < 768
      isTablet.value = windowWidth.value >= 768 && windowWidth.value < 1024
      isDesktop.value = windowWidth.value >= 1024
    }
  }

  // 防抖函数
  const debounce = (func, wait) => {
    let timeout
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout)
        func(...args)
      }
      clearTimeout(timeout)
      timeout = setTimeout(later, wait)
    }
  }

  // 防抖的更新函数
  const debouncedUpdate = debounce(updateWindowSize, 100)

  onMounted(() => {
    if (process.client) {
      // 初始化尺寸
      updateWindowSize()
      
      // 监听窗口大小变化
      window.addEventListener('resize', debouncedUpdate)
    }
  })

  onUnmounted(() => {
    if (process.client) {
      window.removeEventListener('resize', debouncedUpdate)
    }
  })

  return {
    windowWidth,
    windowHeight,
    isMobile,
    isTablet,
    isDesktop,
    updateWindowSize
  }
}
